/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PreanalysisAnswersDto } from '../../models/preanalysis-answers-dto';
import { ProcessingJobModelDto } from '../../models/processing-job-model-dto';

export interface PreanalysisControllerSubmitAnswers$Params {
  uuid: string;
      body: PreanalysisAnswersDto
}

export function preanalysisControllerSubmitAnswers(http: HttpClient, rootUrl: string, params: PreanalysisControllerSubmitAnswers$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessingJobModelDto>> {
  const rb = new RequestBuilder(rootUrl, preanalysisControllerSubmitAnswers.PATH, 'post');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProcessingJobModelDto>;
    })
  );
}

preanalysisControllerSubmitAnswers.PATH = '/match-videos/{uuid}/questions/answers';
